import axios from 'axios';
import React, { useEffect, useState } from 'react'
import * as CONST from "../../../includes/Constant";
import Loading from 'react-fullscreen-loading';
import { SD_CAP_FIRST_LETTER, SD_CAPITALIZE, SD_INVOICE_STATUS, SD_STATUS } from '../../../includes/staticData';

export default function ViewProjects({ project_id }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const fetchProjectData = async (filters) => {
    setLoading(true);
    try {
      const response = await axios.post(CONST.GET_PROJECTS_DETAILS, {
        pid: project_id
      });
      setData(response.data.data);

    } catch (error) {
      console.error("Error fetching projects:", error);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchProjectData();

  }, []);
  const getInvoiceStatus = (statusCode) => {
    const status = SD_STATUS.find((s) => s.code === String(statusCode));

    return status ? (
      <span className={`badge ${status.color}`}>{status.name}</span>
    ) : (
      <span className="badge bg-dark">Unknown</span>
    );
  };
  return (
    <>
      {loading && <Loading loading={loading} />}
      <div className="row mb-3">
        {
          data.map((project) => {
            return (
              <React.Fragment key={project.id}> {/* Use a unique key */}
                <div className="col-md-6 mb-2">
                  <label className="form-label text-muted">Project Name</label>
                  <p>{SD_CAPITALIZE(project?.name || "-")}</p>
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label text-muted">Project Type</label>
                  <p>{SD_CAP_FIRST_LETTER(project?.project_type || "-")}</p>
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label text-muted">Project Status</label>
                  <p>{getInvoiceStatus(project?.status)}</p>
                </div>
              </React.Fragment>
            );
          })
        }
      </div>
    </>
  )
}
